import { createApiAction, restApiActions } from 'redux/redux-actions';
import restApis from 'redux/restApis';
import { GET_MARKET_PLACE_DETAILS, GET_PUBLIC_INFO } from 'redux/constants';

const getPublicInfoApi = restApis('market-place/public-info').list;
const getMarketPlaceDetailsApi = restApis('market-place-details').read;

export const getPublicInfo = createApiAction(GET_PUBLIC_INFO, getPublicInfoApi);
export const getMarketPlaceDetails =
  createApiAction(GET_MARKET_PLACE_DETAILS, getMarketPlaceDetailsApi);

export default restApiActions('market-place');
